import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';
import { isPlatform } from '@ionic/react';
import pckg from '../../../package.json';
import { getFirestoreGlobalVariablesThunk } from '../../redux/firestoreGlobalVariables/action';
import { AppDispatch } from '../../redux';

export const needUpdateWebFocusHandler = (
  setStateHandler: (param: '' | 'show_on_native' | 'show_on_web') => void,
  dispatch: AppDispatch
) => {
  return async () => {
    const result = await dispatch(getFirestoreGlobalVariablesThunk()).unwrap();

    const regExp = new RegExp(/^\d{1,2}\.\d{1,2}\.\d{1,2}$/);
    const currentWebVersion = result?.currentWebVersionUserApp;

    const isNeedUpdateWeb =
      !isPlatform('hybrid') &&
      currentWebVersion &&
      regExp.test(currentWebVersion) &&
      currentWebVersion !== pckg.version;

    if (isNeedUpdateWeb) return setStateHandler('show_on_web');

    return;
  };
};

export const needUpdateWebButtonHandler = () => {
  window.location.reload();
};

export const needUpdateNativeFocusHandler = (
  setStateHandler: (param: '' | 'show_on_native' | 'show_on_web') => void
) => {
  return async () => {
    const nativeUpdateInfo = await AppUpdate.getAppUpdateInfo();
    if (nativeUpdateInfo.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE)
      return setStateHandler('show_on_native');

    return;
  };
};

export const needUpdateNativeButtonHandler = async () => {
  AppUpdate.openAppStore({
    appId: '1599105020',
  });
};
